import { createAsyncThunk } from "@reduxjs/toolkit";
import { getHeaders, 
    getQuestionHints, 
    addQuestionHints as postQuestionHints, 
    updateQuestionHints as putQuestionHints, 
    deleteQuestionHints as removeQuestionHints
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";


// Fetch Table Column Names
export const fetchQuestionHintsTableColumnNames = createAsyncThunk("questionHints/fetchTableColumnNames", async (questionHints, thunkAPI) => {
    try {
      const response = await getHeaders(questionHints); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Fetch All Courses
export const fetchAllQuestionHints = createAsyncThunk("questionHints/fetchAll", async (hint, thunkAPI) => {
    try {
      const response = await getQuestionHints(hint); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Add Course
export const createQuestionHints = createAsyncThunk("questionHints/add", async (questionHints, thunkAPI) => {  
    try {
        const response = await postQuestionHints(questionHints);
        toast.success(response.message);
        return response;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Update Course
export const updateQuestionHints = createAsyncThunk("questionHints/update", async (questionHints, thunkAPI) => {
    try {
        const response = await putQuestionHints(questionHints);
        toast.success(response.message);
        return response.data;
    } catch (error) {
        toast.error(error.message);
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});

// Delete Course
export const deleteQuestionHints = createAsyncThunk("questionHints/delete", async (questionHints, thunkAPI) => {
    try {
        const response = await removeQuestionHints(questionHints);
        toast.success(response.message);
        return response.data;
    } catch (error) {
        toast.error(error.message)
        return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
});